import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const sessionExpiresAt = localStorage.getItem('session_expires_at');
    
    if (sessionExpiresAt && new Date(sessionExpiresAt).getTime() <= Date.now()) {
      logout();
      setLoading(false);
      return;
    }

    try {
      const response = await authAPI.getMe();
      setUser(response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('session_expires_at');
      setUser(null);
    }
    setLoading(false);
  };

  const login = async (credentials) => {
    const response = await authAPI.login(credentials);
    const { user: userData, expires_at } = response.data;
    
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('session_expires_at', expires_at);
    setUser(userData);
    
    return userData;
  };

  const register = async (data) => {
    const response = await authAPI.register(data);
    return response.data;
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      console.warn('Server logout could not be completed:', error);
    }
    localStorage.removeItem('user');
    localStorage.removeItem('session_expires_at');
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isAgent = () => user?.role === 'agent';
  const isStaff = () => user?.role === 'staff';

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin, isAgent, isStaff, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
